import React, { Component } from 'react';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function EngineBayDetailingPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Engine Bay Detailing',
    serviceType: 'Engine Bay Cleaning & Detailing',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Camarillo', 'Ventura', 'Thousand Oaks', 'Ventura County'],
    description: 'Professional mobile engine bay detailing in Ventura County. Safe degreasing, cleaning, and dressing of your engine compartment.'
  };
  const faqs = [{
    question: 'Is engine bay detailing safe for my car?',
    answer: 'Yes. We carefully protect sensitive electrical components and use low-pressure, controlled cleaning with appropriate degreasers. Our experienced technicians know exactly which areas to avoid, keeping your engine safe throughout the process.'
  }, {
    question: 'Why should I get my engine bay detailed?',
    answer: 'A clean engine bay makes it far easier to spot leaks and worn components, helps prevent grime buildup that traps heat, and dramatically improves resale value and presentation when selling your vehicle.'
  }, {
    question: 'How much does engine bay detailing cost in Ventura County?',
    answer: 'Engine bay detailing is often added to a full detail or booked on its own. Pricing depends on the size and condition of the engine bay. Call (818) 381-9905 for a quick quote.'
  }, {
    question: 'Do you come to me for engine bay detailing?',
    answer: 'Yes. Like all our services, engine bay detailing is fully mobile. We bring our own water and detailing equipment to your home or office anywhere in Ventura County. We require access to a standard electrical outlet at the service location.'
  }];
  const breadcrumbs = [{
    name: 'Home',
    item: 'https://www.fulldetailpro.com/'
  }, {
    name: 'Services',
    item: 'https://www.fulldetailpro.com/services'
  }, {
    name: 'Engine Bay Detailing',
    item: 'https://www.fulldetailpro.com/services/engine-bay-detailing'
  }];
  return <ServicePageLayout title="Engine Bay Detailing Ventura County" subtitle="Safe, professional engine bay cleaning that comes to you. Restore a clean, presentable engine compartment without risking sensitive components." metaDescription="Engine bay detailing in Ventura County. Safe mobile degreasing & cleaning of your engine compartment at your home or office. Call Mike's Pro Detail (818) 381-9905." schema={schema} faqs={faqs} breadcrumbs={breadcrumbs} data-id="element-686" data-mp="1etfqz1y3jgqq">
      <p data-id="element-687" data-mp="1ssnprtqckmue">
        A clean engine bay is the finishing touch on a truly detailed vehicle.
        Our <strong data-id="element-688" data-mp="2q7jhtz9e0ork">engine bay detailing in Ventura County</strong> safely
        removes years of grease, dust, and grime from your engine compartment,
        leaving it clean, presentable, and easier to maintain. We perform this
        service on-site as part of our mobile operation, serving Camarillo,
        Ventura, Thousand Oaks, and the surrounding communities.
      </p>

      <h2 data-id="element-689" data-mp="2xt5jayhd8e7e">Our Engine Bay Detailing Process</h2>
      <p data-id="element-690" data-mp="32q5mn1mtz2ut">
        Engine bay cleaning requires care and experience. We protect sensitive
        electrical components, use controlled low-pressure rinsing, and apply
        the right products for each surface:
      </p>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-691" data-mp="3bqkdegikda5p">
        <li className="flex items-start" data-id="element-692" data-mp="3gpwzgz1m2d78">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-693" data-mp="3golvay4973fl" />
          <span data-id="element-694" data-mp="3lgn2i5mke3yr">
            <strong data-id="element-695" data-mp="3li7xtxgpdqxo">Component Protection:</strong> We cover and protect exposed
            electrical connections and sensitive parts before any cleaning
            begins.
          </span>
        </li>
        <li className="flex items-start" data-id="element-696" data-mp="3uiwbgr26ppa1">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-697" data-mp="3ufqq9mwof7jl" />
          <span data-id="element-698" data-mp="3bjuac1axbu4">
            <strong data-id="element-699" data-mp="397bjwnpyxg0">Degreasing:</strong> Safe, effective degreasers break down
            built-up oil, grease, and road grime throughout the bay.
          </span>
        </li>
        <li className="flex items-start" data-id="element-700" data-mp="3hrudq3qbu7k1">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-701" data-mp="3vjqzzr5bdn8i" />
          <span data-id="element-702" data-mp="3vlv4obb1eq9u">
            <strong data-id="element-703" data-mp="3qknwwc8w9r36">Detail Brushing & Rinsing:</strong> Hand brushing of tight
            areas followed by a controlled, low-pressure rinse.
          </span>
        </li>
        <li className="flex items-start" data-id="element-704" data-mp="32vd4pj5m150n">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-705" data-mp="2ytrktdunrqgy" />
          <span data-id="element-706" data-mp="2yvkuz34hcstp">
            <strong data-id="element-707" data-mp="3ct9ea6iwfrwn">Dressing & Protection:</strong> A non-greasy dressing
            restores plastics and hoses to a clean, factory-fresh finish.
          </span>
        </li>
      </ul>

      <h2 data-id="element-708" data-mp="37wiyzlex50ca">Benefits of a Clean Engine Bay</h2>
      <p data-id="element-709" data-mp="s28tpo56woa7">
        Beyond looking great, a detailed engine bay makes it easier to identify
        leaks and worn components, helps prevent grime from trapping heat, and
        significantly boosts your vehicle's resale presentation. It's a smart
        addition to any{' '}
        <Link to="/full-detail" data-id="element-710" data-mp="2a0f2d2xw5ojx">full car detail</Link>.
      </p>

      <h2 data-id="element-711" data-mp="29ykbz93up48g">Related Mobile Detailing Services</h2>
      <div className="not-prose grid grid-cols-1 sm:grid-cols-2 gap-3 my-6" data-id="element-712" data-mp="1w1npfjurm8xd">
        <Link to="/full-detail" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-713" data-mp="20zp7c1ggg279">
          Full Car Detail &rarr;
        </Link>
        <Link to="/services/exterior-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-714" data-mp="2spv1pmxubayr">
          Exterior Detailing &rarr;
        </Link>
        <Link to="/services/mobile-detailing" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-715" data-mp="37op3lfpus89z">
          Mobile Detailing &rarr;
        </Link>
        <Link to="/services/headlight-restoration" className="block px-4 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-716" data-mp="3mam5k16y6dng">
          Headlight Restoration &rarr;
        </Link>
      </div>
    </ServicePageLayout>;
}